import React, { useCallback, useEffect, useMemo, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { LinearProgress } from "@mui/material";
import { toast } from "react-toastify";
import * as api from "../../redux/api";
import { reactIcons } from "../../utils/icons";

import { debounce } from "lodash";
import CustomNoRowsOverlay from "../../utils/styles";
import { useNavigate } from "react-router-dom";
import OrganizationModal from "../../components/modals/OrganizationModal";

import {
  FaCheckCircle,
  FaExclamationCircle,
  FaTimesCircle
} from "react-icons/fa";

const Mines = () => {
  const [open, setOpen] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [searchText, setSearchText] = useState("");

  const [rows, setRows] = useState([]);
  const navigate = useNavigate();

  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10
  });
  const [rowCountState, setRowCountState] = useState(0);

  let totalForms = 6;

  let columns = [
    {
      field: "_id",
      headerName: "S.No.",
      type: "number",
      headerAlign: "center",
      align: "center",
      width: 100
    },
    {
      field: "name",
      headerName: "Name",
      type: "string",
      flex: 2,
      color: "white"
    },
    {
      field: "emailAddress",
      headerName: "Email",
      type: "string",
      flex: 3,
      valueFormatter: (params) => (params.value ? params.value : "-")
    },
    {
      field: "phoneNumber",
      headerName: "Mobile",
      type: "number",
      headerAlign: "left",
      align: "left",
      flex: 2,

      valueFormatter: (params) => (params.value ? params.value : "-")
    },

    {
      field: "registrationStatus",
      headerName: "Status",
      type: "string",
      flex: 2
    },
    {
      field: "createdAt",
      headerName: "Date & Time",
      type: "string",
      flex: 3,
      valueFormatter: (params) => {
        if (!params.value) return "-";

        const date = new Date(params.value);
        return date.toLocaleString("en-US", {
          hour: "numeric",
          minute: "2-digit",
          // second: "2-digit",
          hour12: true,
          year: "numeric",
          month: "2-digit",
          day: "2-digit"
        });
      }
    },

    {
      field: "formFilled",
      headerName: "Form Filled",
      type: "string",
      flex: 2,
      renderCell: (params) => {
        let filledCount = params.row.completedFormsCount || 0;
        let Icon = FaTimesCircle;
        let color = "red";

        if (filledCount === totalForms) {
          Icon = FaCheckCircle;
          color = "green";
        } else if (filledCount > 0) {
          Icon = FaExclamationCircle;
          color = "orange";
        }
        const handleNavigation = () => {
          const id = params.row.id || params.row._id;
          const key = params.row.someKey || "saurabh";
          if (!id) {
            console.error("ID is missing!");
            return;
          }
          const routeMapping = {
            2: `/documentation-checklist/${id}`,
            3: `/beneficial-ownership/${id}`,
            4: `/risk-assesment/${id}`,
            5: `/acknowledgment/${id}`
          };

          if (routeMapping[filledCount]) {
            navigate(routeMapping[filledCount], { state: { key } });
          } else {
            console.error("No route found for filledCount:", filledCount);
          }
        };
        return (
          <div
            className="flex items-center gap-2 cursor-pointer"
            onClick={() => handleNavigation(filledCount)}
          >
            <Icon color={color} />
            <span>
              {filledCount}/{totalForms}
            </span>
          </div>
        );
      }
    },
    {
      field: "action",
      headerName: "View",
      type: "actions",
      flex: 2,
      getActions: (params) => {
        return [
          <div
            key={params.row.id}
            onClick={() => {
              navigate(`/add-mine/${params.row.id}`);
            }}
            style={{ cursor: "pointer" }}
          >
            {reactIcons.eyeVisible}
          </div>
        ];
      }
    }
  ];
  const getUserData = useCallback(async () => {
    setIsLoading(true);
    const response = await api.getUsers(
      paginationModel.page,
      paginationModel.pageSize,
      searchText,
      {},
      "Mine",
      "admin"
    );
    const { data, status } = response;
    if (status >= 200 && status < 300) {
      setIsLoading(false);
      setRowCountState(data.count);
      setRows(
        data.data.map((item, index) => {
          return {
            ...item,
            _id: 8 * paginationModel.page + index + 1
          };
        })
      );
    } else {
      setIsLoading(false);
      toast.error(data.message);
    }
  }, [paginationModel, searchText]);

  const debouncedFetchUsers = useMemo(() => {
    return debounce(getUserData, 500);
  }, [getUserData]);

  useEffect(() => {
    debouncedFetchUsers();
    return () => {
      debouncedFetchUsers.cancel();
    };
  }, [debouncedFetchUsers]);

  return (
    <>
      <div className="w-full mt-10 data-grid ">
          <div className="mb-6">
          <div className="flex justify-between items-center">
            <div className="flex gap-4 items-center">
              <h4 className="">Mines</h4>
              <button
                type="button"
                className="btn btn-primary flex justify-between items-center gap-2"
                onClick={() => navigate("/mine-user-list")}
              >
                Mine Request
              </button>
            </div>
            <div className="flex flex-col justify-end items-end gap-2">
              <div className="flex gap-2">
                <div className="relative">
                  <input
                    className="w-[250px] h-[45px] bg-transparent"
                    type="text"
                    value={searchText}
                    placeholder="Search by name, email"
                    onChange={(e) => setSearchText(e.target.value)}
                  />
                  <span className="absolute text-18 top-[calc(50%-9px)] right-2">
                    {reactIcons.search}
                  </span>
                </div>

                <button
                  type="button"
                  className="btn btn-primary flex justify-between items-center gap-2"
                  onClick={() => navigate("/add-mine")}
                >
                  <span className="text-black  text-22">
                    {reactIcons.addUser}
                  </span>
                  Add Mine
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="h-[600px] w-full !text-black mt-4">
          <DataGrid
            loading={isLoading}
            rows={rows}
            getRowId={(row) => row._id}
            getEstimatedRowHeight={() => 52}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 10
                }
              }
            }}
            rowCount={rowCountState}
            pageSizeOptions={[10]}
            paginationModel={paginationModel}
            paginationMode="server"
            onPaginationModelChange={setPaginationModel}
            slots={{
              loadingOverlay: LinearProgress,
              noRowsOverlay: CustomNoRowsOverlay
            }}
            disableColumnMenu
            disableRowSelectionOnClick
            sx={{
              "& .MuiDataGrid-row:hover": {
                cursor: "default"
              },
              "& .MuiDataGrid-root": {
                color: "black"
              },
              "& .MuiDataGrid-cell": {
                color: "black"
              },
              "& .MuiDataGrid-columnHeaders": {
                color: "black"
              },
              "& .MuiDataGrid-columnHeaderTitle": {
                color: "black"
              },
              "& .MuiDataGrid-columnHeader": {
                color: "black"
              },
              "& .MuiTablePagination-root": {
                color: "white"
              },
              "& .MuiSvgIcon-root": {
                color: "white"
              }
            }}
          />
        </div>
      </div>
      {open && (
        <OrganizationModal
          open={open}
          handleClose={() => {
            setOpen(false);
            debouncedFetchUsers();
          }}
          // userDetail={userData}
        />
      )}
    </>
  );
};

export default Mines;
